import script from "./ProjectView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectView.vue?vue&type=style&index=0&id=2612b165&lang=scss"

const __exports__ = script;

export default __exports__